import React from 'react';
import DocumasterFont from "./DocumasterFont";

/**
 *-2 - nieznany stan tonera (?),
 * -100 - prawie pusty 1-10%,
 * -3 - jak widać to trochę, czyli 10-100%,
 **/
const tonerLabel = (value) => {
  switch(value) {
    case -3: return 'trochę';
    case -2: return 'nieznany';
    case -100: return 'prawie pusty';
    case 0: return 'pusty';
    default: return value;
  }
}

const TonerLevel = ({label, customStyle, value}) => {
  return (
      <span title={label}>
      <DocumasterFont label={label} symbol="toner" style={customStyle}/>
        {tonerLabel(value)}
    </span>
  );
}

const tonerColors = {
  cyan: '#00bcd4',
  magenta: '#e91e63',
  yellow: '#f7c500',
  black: '#212529',
};

const tonerLevelClass = (value) => {
  if (value === null || value === undefined || value === '' || value === -2) return 'muted';
  if (value === 0) return 'danger';
  if (value === -100 || (typeof value === 'number' && value > 0 && value <= 20)) return 'warning';
  return 'ok';
}

const tonerLevelColors = {
  ok: '#198754',
  warning: '#c97a00',
  danger: '#b02a37',
  muted: '#ced4da',
};

const tonerBarWidth = (value) => {
  if (typeof value === 'number' && value >= 0 && value <= 100) return value;
  if (value === -100) return 5;     // prawie pusty
  if (value === 0) return 0;        // pusty
  if (value === -3) return 100;     // trochę / nieznany — pełna szerokość, ale wizualnie "puste"
  return null;                       // -2 nieznany
}

const TonerBar = ({label, customStyle, value, compact = false}) => {
  const width = tonerBarWidth(value);
  const swatchColor = tonerColors[customStyle] || '#6c757d';
  const levelClass = tonerLevelClass(value);
  const levelColor = tonerLevelColors[levelClass] || tonerLevelColors.muted;
  const isUnknown = value === -2 || width === null;
  const fillWidth = isUnknown ? 100 : (width !== null ? width : 0);
  const valueText = typeof value === 'number' && value >= 0 ? `${value}%` : tonerLabel(value);

  if (compact) {
    return (
        <div className={`toner-bar toner-bar-compact level-${levelClass}`}
             title={`${label}: ${valueText}`}>
          <span className={`toner-swatch toner ${customStyle}`} style={{backgroundColor: swatchColor}}/>
          <div className="toner-bar-track">
            <div
                className={`toner-bar-fill level-${levelClass} ${isUnknown ? 'is-unknown' : ''}`}
                style={{width: `${fillWidth}%`, backgroundColor: isUnknown ? '#ced4da' : levelColor}}
            />
          </div>
        </div>
    );
  }

  return (
      <div className="toner-bar" title={label}>
        <div className="toner-bar-label">
          <span className={`toner-swatch toner ${customStyle}`} style={{backgroundColor: swatchColor}}/>
          <span className="toner-bar-name">{label}</span>
          <span className={`toner-bar-value level-${levelClass}`}>
            {valueText}
          </span>
        </div>
        <div className="toner-bar-track">
          <div
              className={`toner-bar-fill level-${levelClass} ${isUnknown ? 'is-unknown' : ''}`}
              style={{width: `${fillWidth}%`, backgroundColor: isUnknown ? '#ced4da' : levelColor}}
          />
        </div>
      </div>
  );
}

const hasTonerValue = (value) => value !== null && value !== undefined && value !== '';

const TonersInfo = ({printer, variant = 'inline'}) => {
  let t = [];
  if (hasTonerValue(printer.tonerCyan)) {
    t.push({ label: "Cyjan", customStyle: "cyan", value: printer.tonerCyan });
  }
  if (hasTonerValue(printer.tonerMagenta)) {
    t.push({ label: "Magenta", customStyle: "magenta", value: printer.tonerMagenta });
  }
  if (hasTonerValue(printer.tonerYellow)) {
    t.push({ label: "Żółty", customStyle: "yellow", value: printer.tonerYellow });
  }
  if (hasTonerValue(printer.tonerBlack)) {
    t.push({ label: "Czarny", customStyle: "black", value: printer.tonerBlack });
  }
  if (variant === 'bars') {
    return <div className="toner-bars">{t.map(e=><TonerBar key={e.label} {...e}/>)}</div>;
  }
  if (variant === 'bars-compact') {
    if (!t.length) return <span className="empty-cell">—</span>;
    return <div className="toner-bars toner-bars-compact">{t.map(e=><TonerBar key={e.label} compact {...e}/>)}</div>;
  }
  return <span>{t.map(e=><TonerLevel key={e.label} {...e}/>)}</span>;
}

export default TonersInfo;